
import { TranslationSet } from '../types';

export const landing: TranslationSet = {
  'landing.title': {
    en: 'Document your baby\'s journey',
    ja: '赤ちゃんの成長を記録しましょう',
    es: 'Documenta tu viaje de bebé',
    zh: '记录宝宝的成长',
    fa: 'مستندسازی سفر کودک شما'
  },
  'landing.subtitle': {
    en: 'Create beautiful diary entries with our AI assistant',
    ja: 'AIアシスタントで美しい日記エントリーを作成',
    es: 'Crea entradas de diario hermosas con nuestra aplicación AI',
    zh: '使用我们的AI助手创建美丽的日记条目',
    fa: 'با کمک دستیار هوشمند ما، یادداشت‌های زیبای دفتر خاطرات را ایجاد کنید'
  },
  'landing.getStarted': {
    en: 'Get Started',
    ja: '始めましょう',
    es: 'Empezar',
    zh: '开始',
    fa: 'شروع کنید'
  },
  'landing.learnMore': {
    en: 'Learn More',
    ja: '詳細を見る',
    es: 'Más información',
    zh: '了解更多',
    fa: 'بیشتر بدانید'
  },
  'landing.exampleTitle': {
    en: 'Sample Entry: First Steps',
    ja: 'サンプルエントリー：最初の一歩',
    es: 'Ejemplo de entrada: primeros pasos',
    zh: '示例条目：第一次步',
    fa: 'نمونه یادداشت: اولین قدم‌ها'
  },
  'landing.captureSpecialMoments': {
    en: 'Capture Special Moments',
    ja: '特別な瞬間を記録する',
    es: 'Captura momentos especiales',
    zh: '捕捉特别的时刻',
    fa: 'ثبت لحظات ویژه'
  },
  'landing.photoGalleryDescription': {
    en: 'Save and organize your baby\'s precious moments in our beautiful gallery',
    ja: '美しいギャラリーで赤ちゃんの大切な瞬間を保存して整理',
    es: 'Guarda y organiza tus momentos más valiosos en nuestra hermosa galería',
    zh: '在我们的美丽画廊中保存和组织宝宝的珍贵时刻',
    fa: 'لحظات ارزشمند کودک خود را در گالری زیبای ما ذخیره و سازماندهی کنید'
  },
  'landing.exploreGallery': {
    en: 'Explore Gallery',
    ja: 'ギャラリーを見る',
    es: 'Explora la galería',
    zh: '探索画廊',
    fa: 'گالری را مشاهده کنید'
  },
  'landing.features.title': {
    en: 'Features for Parents',
    ja: '親のための機能',
    es: 'Características para padres',
    zh: '为父母设计的功能',
    fa: 'ویژگی‌ها برای والدین'
  },
  'landing.features.description': {
    en: 'Everything you need to document your baby\'s milestones',
    ja: '赤ちゃんのマイルストーンを記録するために必要なすべて',
    es: 'Todo lo que necesitas para documentar los hitos de tu bebé',
    zh: '记录宝宝里程碑所需的一切',
    fa: 'همه چیزهایی که برای ثبت مراحل رشد کودک خود نیاز دارید'
  },
  'landing.growthTracking': {
    en: 'Track Growth and Development',
    ja: '成長と発達を追跡',
    es: 'Seguimiento de crecimiento',
    zh: '跟踪成长和发育',
    fa: 'پیگیری رشد و تکامل'
  },
  'landing.growthTrackingDescription': {
    en: 'Monitor your baby\'s height and weight with beautiful visualizations',
    ja: '美しいビジュアライゼーションで赤ちゃんの身長と体重を監視',
    es: 'Monitorea el crecimiento de tu bebé con gráficos visuales',
    zh: '使用美丽的可视化图表监控宝宝的身高和体重',
    fa: 'قد و وزن کودک خود را با نمودارهای زیبا پیگیری کنید'
  },
  'landing.interactiveGrowthCharts': {
    en: 'Interactive Growth Charts',
    ja: 'インタラクティブな成長チャート',
    es: 'Gráficos de crecimiento interactivos',
    zh: '交互式成长图表',
    fa: 'نمودارهای رشد تعاملی'
  },
  'landing.trackVisualCharts': {
    en: 'Track growth with visual charts',
    ja: 'ビジュアルチャートで成長を追跡',
    es: 'Seguir el crecimiento con gráficos visuales',
    zh: '通过可视化图表跟踪成长',
    fa: 'پیگیری رشد با نمودارهای تصویری'
  },
  'landing.heightWeightTracking': {
    en: 'Height & Weight Tracking',
    ja: '身長と体重の追跡',
    es: 'Seguimiento de altura y peso',
    zh: '身高和体重跟踪',
    fa: 'پیگیری قد و وزن'
  },
  'landing.heightWeightDescription': {
    en: 'Track your baby\'s physical development over time',
    ja: '時間とともに赤ちゃんの身体発達を追跡',
    es: 'Monitorea el desarrollo físico de tu bebé a lo largo del tiempo',
    zh: '跟踪宝宝在时间上的身体发育',
    fa: 'رشد جسمی کودک خود را در طول زمان پیگیری کنید'
  },
  'landing.customizableDateRanges': {
    en: 'Customizable Date Ranges',
    ja: 'カスタマイズ可能な日付範囲',
    es: 'Rangos de fechas personalizables',
    zh: '可定制日期范围',
    fa: 'محدوده‌های تاریخ قابل تنظیم'
  },
  'landing.dateRangesDescription': {
    en: 'Select custom timeframes to view growth progress',
    ja: 'カスタムの時間枠を選択して成長の進捗を確認',
    es: 'Selecciona rango de fechas personalizables para ver el progreso de crecimiento',
    zh: '选择自定义时间框架以查看成长进度',
    fa: 'بازه‌های زمانی سفارشی را برای مشاهده پیشرفت رشد انتخاب کنید'
  },
  'landing.visualGrowthIndicators': {
    en: 'Visual Growth Indicators',
    ja: '視覚的な成長指標',
    es: 'Indicadores de crecimiento visuales',
    zh: '视觉成长指标',
    fa: 'شاخص‌های تصویری رشد'
  },
  'landing.visualGrowthDescription': {
    en: 'See how your baby is growing compared to standards',
    ja: '見比べて赤ちゃんの成長を確認',
    es: 'Ver cómo tu bebé está creciendo en comparación con los estándares',
    zh: '查看宝宝如何与标准相比成长',
    fa: 'ببینید کودک شما در مقایسه با استانداردها چگونه رشد می‌کند'
  },
  'landing.viewStatistics': {
    en: 'View Statistics',
    ja: '統計を見る',
    es: 'Ver estadísticas',
    zh: '查看统计',
    fa: 'مشاهده آمار'
  }
};
